<template>
  <div class="input-container">
    <label
      for="last_name"
      class="input__label"
    >Last Name</label>
    <input
      id="last_name"
      v-model.lazy="$v.lName.$model"
      class="input"
      :class="{'input--error' : ($v.lName.$invalid === true && $v.lName.$error === true)}"
      type="text"
      name="last_name"
      @focusout="updateName"
    >
    <span
      v-show="($v.lName.$invalid === true && $v.lName.$error === true)"
      class="input__error"
    >
      Invalid last name
    </span>
  </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators'

export default {
  props: {
    lastName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      lName: ''
    }
  },
  watch: {
    '$v.lName.$invalid': function (val) {
      if (val === false) {
        this.$emit('input', this.lName.trim())
      }
      this.$emit('valid', (val === false), this.$options._componentTag)
    }
  },
  validations: {
    lName: {
      required,
      minLength: minLength(3),
      hasVowel (lName) {
        if (lName.match(/[0-9]/g)) {
          return false
        }
        return !!lName.toLowerCase().match(/[aeiou]/gi)
      }
    }
  },
  mounted () {
    if (this.lastName) { this.lName = this.lastName }
  },
  methods: {
    updateName () {
      if (this.lName.$invalid !== true && this.lName.$error !== true) {
        this.$emit('input', this.lName.trim())
      }
    },
    triggerTouch () {
      this.$v.$touch()
    },
    onInput (e) {
      e.target.value = e.target.value.replace(/\s/g, '')
    }
  }
}
</script>
